"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useConceptOfferHintDisplayedItems = void 0;
var _react = require("react");
const useConceptOfferHintDisplayedItems = (param)=>{
    let { getItemsEligibleForExpandAll, handleChangeItemQuantity, handleToggleItem, isBenefitsMaximumLimitMet, isOfferApplicable, isRequirementMet, items1stSection, items1stSectionPrices, items2ndSection, items2ndSectionPrices, seeAllItems1stSectionHandler, triggerSeeAllItems2ndSectionAction, visibleItemsCount1stSection, visibleItemsCount2ndSection } = param;
    const displayedItems1stSection = (0, _react.useMemo)(()=>items1stSection// only currently shown items in the expandable area
        .filter((x, index)=>index < visibleItemsCount1stSection)// display purchases first
        .sort((a, b)=>{
            const purchaseA = a.purchasedQuantity > 0;
            const purchaseB = b.purchasedQuantity > 0;
            if (purchaseA > purchaseB) {
                return -1;
            }
            if (purchaseA < purchaseB) {
                return 1;
            }
            return 0;
        })// merge with total prices, setup handlers
        .map((item, index, param)=>{
            let { length: itemsCount } = param;
            const { availableQuantity, isBenefit, itemCode, purchasedQuantity, replacement = null, selectedQuantity } = item;
            const { price, purchasePrice } = items1stSectionPrices.find((x)=>x.itemCode === itemCode);
            const onChangeQuantity = (quantity)=>handleChangeItemQuantity(itemCode, quantity, isBenefit);
            const onToggleItem = (shouldSelect)=>{
                handleToggleItem(itemCode, shouldSelect, isBenefit);
                const eligibleCount = getItemsEligibleForExpandAll();
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- I'd rather not change existing logic
                const itemsOnLastRow = itemsCount % eligibleCount || eligibleCount;
                if (index >= itemsCount - itemsOnLastRow) {
                    seeAllItems1stSectionHandler();
                }
            };
            return {
                ...item,
                couldDeselect: purchasedQuantity === 0,
                isDisabled: !isOfferApplicable(),
                isOutOfStock: availableQuantity === 0,
                isRequirementMet,
                isSelected: selectedQuantity > 0,
                onChangeQuantity,
                onToggleItem,
                price,
                purchasePrice,
                replacement
            };
        }), [
        getItemsEligibleForExpandAll,
        handleChangeItemQuantity,
        handleToggleItem,
        isOfferApplicable,
        isRequirementMet,
        items1stSection,
        items1stSectionPrices,
        seeAllItems1stSectionHandler,
        visibleItemsCount1stSection
    ]);
    const displayedItems2ndSection = (0, _react.useMemo)(()=>items2ndSection.filter((x, index)=>index < visibleItemsCount2ndSection).map((item, index, param)=>{
            let { length: itemsCount } = param;
            const { availableQuantity, isBenefit, itemCode, selectedQuantity, purchasedQuantity } = item;
            const { price, purchasePrice } = items2ndSectionPrices.find((x)=>x.itemCode === itemCode);
            const onChangeQuantity = (quantity)=>handleChangeItemQuantity(itemCode, quantity, isBenefit);
            const onToggleItem = (shouldSelect)=>{
                handleToggleItem(itemCode, shouldSelect, isBenefit);
                triggerSeeAllItems2ndSectionAction(itemsCount, index);
            };
            return {
                ...item,
                couldDeselect: purchasedQuantity === 0,
                isDisabled: !isOfferApplicable(),
                isOutOfStock: availableQuantity === 0,
                isRequirementMet: isBenefitsMaximumLimitMet,
                isSelected: selectedQuantity > 0,
                price,
                purchasePrice,
                onChangeQuantity,
                onToggleItem
            };
        }), [
        handleChangeItemQuantity,
        handleToggleItem,
        isBenefitsMaximumLimitMet,
        isOfferApplicable,
        items2ndSection,
        items2ndSectionPrices,
        triggerSeeAllItems2ndSectionAction,
        visibleItemsCount2ndSection
    ]);
    return {
        displayedItems1stSection,
        displayedItems2ndSection
    };
};
exports.useConceptOfferHintDisplayedItems = useConceptOfferHintDisplayedItems;
